import { render, staticRenderFns } from "./ClientPhone.vue?vue&type=template&id=0ddd0d7e&scoped=true"
import script from "./ClientPhone.vue?vue&type=script&lang=js"
export * from "./ClientPhone.vue?vue&type=script&lang=js"
import style0 from "./ClientPhone.vue?vue&type=style&index=0&id=0ddd0d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd0d7e",
  null
  
)

export default component.exports